<template>
  <main class="main__simple simple">
    <div class="simple__container container">
      <h1 v-if="!page.show_news" v-text="page.title" />
      <article :class="articleClass">
        <section :class="['simple__section', 'simple__section--'+section.type, 'simple__section--'+page.slug]"
          v-for="(section, s) in page.sections" :key="s">
          <div class="simple__rich" v-if="section.type==='rich'" v-html="section.text"
          />
          <div class="simple__media" v-if="section.type==='image'">
            <img class="simple__image" :src="mediaPath(section.image)" :alt="page.title" :title="page.title" />
          </div>
          <div class="simple__private private" v-if="section.type==='private-label'">
            <div class="private__background" :style="bg(section.gif_background)">
              <img :src="mediaPath(section.gif)" :alt="page.title + ' ' + '1'" :title="page.title + ' ' + '1'" class="private__gif" />
            </div>
          </div>
        </section>
        <section v-if="page.show_news===1 && post['show_'+$store.getters.lang]===1"
          class="simple__section simple__section--excerpt" v-for="(post) in $store.getters.news"
          :key="post.id">
          <div class="simple__date" v-text="post.date.slice(0, -9)" />
          <!-- <div v-if="post.date" class="simple__date" v-text="post.date.slice(0, -9)" /> -->
          <router-link :to="moreUrl(post.slug)" class="simple__subtitle"
            v-text="post.title" />
          <div class="simple__excerpt" v-text="truncate(post.content, 600)"
          />
          <router-link class="simple__more more" :to="moreUrl(post.slug)">
            <span class="more__text" v-text="$store.getters.ui.read_more_label"
            />
            <i class="more__arrow" />
          </router-link>
        </section>
      </article>
      <request v-if="page.request" :page="page" class="simple__request"
      />
    </div>
  </main>
</template>

<script>
import page from '@/mixins/page'
import Request from '@/components/Request'

import ifDefined from '@/tools/ifDefined'

export default {
  mixins: [page],
  components: {
    Request
  },
  computed: {
    isSubpage() {
      return ifDefined(this.page.parent)
    },
    articleClass() {
      var list = [
        'simple__article',
        'simple__article--' + this.$store.getters.page.slug
      ]
      if (this.isSubpage) {
        list.push('simple__article--sub')
      }
      return list
    }
  },
  methods: {
    moreUrl(slug) {
      return '../' + slug
    }
  },
  name: 'SimpleTemplate'
}
</script>



// WEBPACK FOOTER //
// src/templates/SimpleTemplate.vue